import { useCallback, useState } from "react";

const useStatusContentHook = (statuses = []) => {
	const [selectedStatus, setSelectedStatus] = useState([]);

	const toggleStatus = useCallback(
		(status) => {
			const isIn = !!selectedStatus.find((s) => s === status);
			if (isIn) setSelectedStatus((list) => list.filter((s) => s !== status));
			else setSelectedStatus((l) => [...l, status]);
		},
		[selectedStatus, setSelectedStatus]
	);

	const toggleAllStatus = useCallback(() => {
		if (selectedStatus.length === statuses.length) setSelectedStatus([]);
		else setSelectedStatus(statuses.map((s) => s.id));
	}, [selectedStatus, setSelectedStatus, statuses]);

	return { toggleStatus, toggleAllStatus, selectedStatus, setSelectedStatus };
};

export default useStatusContentHook;
